module.exports = __webpack_public_path__ + "f32805eb878bdb190e3e63a45ab09c15.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/magic-wand-right-s.png
// module id = 2674
// module chunks = 0